import {Injectable} from '@angular/core'
import {NbToastrService} from '@nebular/theme'
import {Store} from '../../../@core/store/store'
import {I18nService, extract} from '../../../@core/translate/i18n.service'

@Injectable({providedIn: 'root'})
export class PageService {
  constructor(private toasterService: NbToastrService, private i18nService: I18nService) { }

  async submit(mode: 'create' | 'change', store: Store<any>, formValue: any): Promise<any> {
    if (mode === 'create') {
      try {
        const item = await store.createItem(formValue)
        if (item) {
          formValue = {...formValue, ...item}
        }
        this.toasterService.show(
          this.i18nService.tr(extract(`toast.created.title`)),
          this.i18nService.tr(extract(`toast.created.message`)),
          {status: 'success'}
        )
      } catch (e) {
        this.showError(e, extract(`toast.created.error.title`))
        throw e
      }
    } else {
      try {
        await store.updateItem(store.item.id, formValue)
        this.toasterService.show(
          this.i18nService.tr(extract(`toast.changed.title`)),
          this.i18nService.tr(extract(`toast.changed.message`)),
          {status: 'success'}
        )
      } catch (e) {
        this.showError(e, extract(`toast.changed.error.title`))
        throw e
      }
    }

    return formValue
  }

  showError(e: string, title: string = 'toast.error.title', translate: boolean = true, translateMessage: boolean = false) {
    this.toasterService.show(translateMessage ? this.i18nService.tr(e) : e, translate ? this.i18nService.tr(title) : title, {status: 'danger'})
  }

  changed(message: string = 'toast.changed.message', title: string = 'toast.changed.title', translate: boolean = true) {
    this.toasterService.show(
      translate ? this.i18nService.tr(message) : message,
      translate ? this.i18nService.tr(title) : title,
      {status: 'success'}
    )
  }

  created() {
    this.toasterService.show(
      this.i18nService.tr(extract(`toast.created.title`)),
      this.i18nService.tr(extract(`toast.created.message`)),
      {status: 'success'}
    )
  }

  removed() {
    this.toasterService.show(
      this.i18nService.tr(extract(`toast.removed.title`)),
      this.i18nService.tr(extract(`toast.removed.message`)),
      {status: 'success'}
    )
  }
}
